import { render, staticRenderFns } from "./WorkflowDefinitionCreate.vue?vue&type=template&id=51d09fde&"
import script from "./WorkflowDefinitionCreate.vue?vue&type=script&lang=js&"
export * from "./WorkflowDefinitionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports